/* eslint-disable operator-linebreak */
import { getCurrentYear } from '../DateUtil';

// Home page
export const HOME_PAGE_TITLE =
  'Подбор тура по всем туроператорам: сравни предложения и выбери лучшее!';
export const HOME_PAGE_META_DESCRIPTION =
  'TourHunter - сервис поиска туров онлайн по всем туроператорам✈ Купить тур по цене туроператора или ниже✔️ без посещения офиса✔️ Все документы на почту';
export const HOME_PAGE_IMAGE_ALT = 'Подбор тура по всем туроператорам';

// About
export const ABOUT_TITLE = 'О нас';
export const ABOUT_DESCRIPTION =
  'Покупка онлайн сэкономит ваши самые ценные ресурсы — время и деньги: так как вы можете забронировать тур из любого места в любое время без посещения агентства и звонка по телефону.';

// Contacts
export const CONTACTS_TITLE = 'Контакты';
export const CONTACTS_DESCRIPTION =
  'На этой странице вы найдете информацию о компании TourHunter.by';

// FAQ
export const FAQ_TITLE = 'Часто задаваемые вопросы';
export const FAQ_DESCRIPTION =
  'На этой странице вы найдете ответы на часто задаваемые вопросы';

// Tury is Minska
export const TURY_MINKS_TITLE =
  'Туры из Минска от всех туроператоров онлайн: ваш идеальный отдых в один клик!';
export const TURY_MINKS_DESCRIPTION = `Туры из Минска на море ${getCurrentYear()} – самые выгодные цены и предложения от всех туроператоров✔️ Забронируйте свой идеальный отпуск`;

// Podbor
export const PODBOR_TITLE =
  'Подбор тура по всем туроператорам онлайн: сравни предложения и выбери лучшее!';
export const PODBOR_DESCRIPTION =
  'TourHunter - сервис бронирования туров онлайн✔️ На нашей платформе вы можете легко сравнить туры от всех ведущих туроператоров✔️ без посещения офиса✔️';

// Tyrkey
export const TURKEY_TITLE = `Туры в Турцию из Минска. Актуальные цены ${getCurrentYear()}`;
export const TURKEY_DESCRIPTION = `Туры в Турцию ${getCurrentYear()}✔️ Узнайте о лучших предложениях и горящих турах из Минска✔️ Планируйте свой идеальный отдых уже сегодня!`;

// Egypt
export const EGYPT_TITLE = `Туры в Египет из Минска. Актуальные цены ${getCurrentYear()}`;
export const EGYPT_DESCRIPTION =
  'Подбор тура в Египет из Минска в пару кликов! Мы предлагаем лучшие предложения для вашего идеального отдыха';

// Georgia
export const GEORGIA_TITLE = `Туры в Грузию из Минска. Актуальные цены ${getCurrentYear()}`;
export const GEORGIA_DESCRIPTION =
  'Туры в Грузию на самолете из Минска: идеальный отдых в пару кликов✔️';

// Georgia
export const UAE_TITLE = `Туры в ОАЭ из Минска. Актуальные цены ${getCurrentYear()}`;
export const UAE_DESCRIPTION = `Тур в ОАЭ из Минска ${getCurrentYear()}✔️ лучшие цены и горящие предложения!`;

export const HOTEL_DETAILS_TITLE = 'Отель';
export const ORDER_DETAILS_TITLE = 'Тур';
export const CHECKOUT_TITLE = 'Оформление заказа';

// Search
export const SEARCH_TITLE = 'Поиск туров';
export const SEARCH_DESCRIPTION =
  'TourHunter - сервис поиска туров онлайн по всем туроператорам✈ Купить тур по цене туроператора или ниже✔️';

// China
export const CHINA_TITLE = `Туры в Китай ${getCurrentYear()} — Вылеты из Минска, выгодные предложения`;
export const CHINA_DESCRIPTION = `Туры в Китай из Минска: от экскурсий по Пекину до отдыха на острове Хайнань. Успейте забронировать на ${getCurrentYear()} год — надёжно, удобно, с гарантией лучших цен.`;

// Quatar
export const QATAR_TITLE = `Туры в Катар из Минска ${getCurrentYear()} — предложения от всех туроператоров`;
export const QATAR_DESCRIPTION =
  'Купить тур в Катар из Минска — легко! Подберите путешествие: горящие туры, прямые вылеты, отели 4–5★. Выгодные цены.';

// Oman
export const OMAN_TITLE = `Туры в Оман ${getCurrentYear()} — Восточная экзотика из Минска`;
export const OMAN_DESCRIPTION = `Ищете необычный отдых? Туры в Оман из Минска — идеальный выбор! Пляжи Индийского океана, горы и древние города. Все туры ${getCurrentYear()} года — в одном месте.`;

// Thailand
export const THAILAND_TITLE = `Туры в Таиланд из Минска ${getCurrentYear()} — Пхукет, Паттайя, Самуи`;
export const THAILAND_DESCRIPTION =
  'Туры в Таиланд из Минска по ценам туроператоров✔️ Пхукет, Паттайя, Самуи и Краби✔️ Сравните предложения всех туроператоров и забронируйте отдых онлайн!';

// Russia
export const RUSSIA_TITLE = `Туры в Россию ${getCurrentYear()} — Откройте новые горизонты путешествий!`;
export const RUSSIA_DESCRIPTION =
  'Откройте для себя курорты России! Путешествия на Черное и Азовское моря, туры по уникальным уголкам природы и городам. Вылеты из Минска!';

export const HOT_TITLE = `Горящие туры из Минска онлайн – лучшие предложения ${getCurrentYear()} TourHunter.by`;
export const HOT_DESCRIPTION = `Ищете горящие туры из Минска? На TourHunter.by вы найдете самые выгодные предложения ${getCurrentYear()} года! Бронируйте онлайн, сравнивайте цены, выбирайте лучшие направления и отдыхайте выгодно.`;
